const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCameraOff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1325",
    d: "M658.774 30.945h-4.38l-2.159-3.223a1 1 0 0 0-.831-.444h-7.364a1 1 0 0 0-.831.444l-2.157 3.223h-4.373a3.453 3.453 0 0 0-3.457 3.444v13.447a3.454 3.454 0 0 0 3.448 3.442h22.1a3.456 3.456 0 0 0 3.45-3.441V34.386a3.456 3.456 0 0 0-3.446-3.441zm1.449 16.886a1.453 1.453 0 0 1-1.452 1.447h-22.1a1.451 1.451 0 0 1-1.45-1.444V34.391a1.452 1.452 0 0 1 1.452-1.446h4.912a1 1 0 0 0 .831-.444l2.157-3.223h6.3l2.158 3.223a1 1 0 0 0 .831.444h4.914a1.452 1.452 0 0 1 1.45 1.444z",
    transform: "translate(-629.222 -21.278)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1326",
    d: "M647.726 34.6a5.894 5.894 0 1 0 5.894 5.894 5.893 5.893 0 0 0-5.893-5.893zm0 9.788a3.894 3.894 0 1 1 0-7.788 3.894 3.894 0 0 1 0 7.788z",
    transform: "translate(-629.222 -21.278)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 317",
    transform: "translate(6.252 7.5)",
    style: {
      stroke: "#ff3e72",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "current"
    },
    d: "M24.499 0 0 24.5"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraOff);
export default __webpack_public_path__ + "static/media/icon-camera-off.4bd383c0da2213d3aa6b4270b4541c52.svg";
export { ForwardRef as ReactComponent };